module.exports = __webpack_public_path__ + "media/fonts/Inter-Thin-97a5cc3c.ttf";